module.exports = __webpack_public_path__ + "img/sale_dark.f11a88ce.svg";